import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import Header from './Header';
import AnnouncementsAndTasks from './AnnouncementsAndTasks';
import { useOperationsContext } from '../../../context/OperationsContextProvider';
import DailyBrief from './DailyBrief';
import Calendar from './Calender';
import AddAnnouncement from './Modals/AddAnnouncement';
import useScreenSize from '../../../hooks/useScreenSize';
import AddEditCheckList from './Modals/AddEditCheckList';
import ChecklistApproval from './Modals/ChecklistApproval';

function OperationsMain() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [showApproveChecklist, setShowApproveChecklist] = useState<
    string | null
  >(null);

  const {
    showDailyBriefScreen,
    showCalendarScreen,
    openAddEditAnnouncementDialog,
    setOpenAddEditAnnouncementDialog,
    selectedAnnouncementForEdit,
    setSelectedAnnouncementForEdit,
    announcementModalMode,
    setAnnouncementModalMode,
    openAddCheckListDialog,
    setOpenAddCheckListDialog,
  } = useOperationsContext();

  const screenSize = useScreenSize();
  const isSmall = screenSize !== 'xl' && screenSize !== '2xl';

  const handleCloseAddAnnouncementDialog = () => {
    setOpenAddEditAnnouncementDialog(false);
    setSelectedAnnouncementForEdit(null);
    setAnnouncementModalMode('create');
  };

  const handleCloseAddCheckListDialog = () => {
    setOpenAddCheckListDialog(false);
  };

  useEffect(() => {
    const state = location.state as any;

    if (!state?.checklistApprovalId) return;

    setShowApproveChecklist(state.checklistApprovalId);
    navigate('/operations', {replace: true, state: null});
  }, [location.state, navigate]);

  return (
    <>
      <div className="w-full h-full flex flex-col gap-2 bg-grayLightBg min-h-0 overflow-hidden">
        <Header />

        {isSmall ? (
          <div className="flex-1 flex flex-col gap-2 min-h-0 overflow-y-hidden">
            <div className="flex flex-col gap-2 overflow-y-auto p-2">
              {/* AnnouncementsAndTasks */}
              <div className="rounded-[12px] p-2 bg-white">
                <AnnouncementsAndTasks />
              </div>

              {/* DailyBrief */}
              {showDailyBriefScreen && (
                <div className="rounded-[12px] p-2 bg-white">
                  <DailyBrief />
                </div>
              )}

              {/* Calendar */}
              <div className="rounded-[12px] p-2 bg-white">
                <Calendar />
              </div>
            </div>
          </div>
        ) : (
          <div className="flex-1 flex gap-2 min-h-0 overflow-x-auto overflow-y-hidden">
            <div
              className={`flex-1 h-full bg-white border-b ${
                i18n.language == 'heb'
                  ? 'rounded-tl-[32px]'
                  : 'rounded-tr-[32px]'
              }`}
            >
              <AnnouncementsAndTasks />
            </div>

            {showDailyBriefScreen && (
              <div className="max-w-[380px] min-w-[380px] h-full bg-white rounded-tl-[32px] rounded-tr-[32px] rounded-bl-[32px] rounded-br-[32px] border-4 flex-grow">
                <DailyBrief />
              </div>
            )}

            {showCalendarScreen && (
              <div
                className={`max-w-[400px] min-w-[400px] h-full bg-white flex-grow border-b ${
                  i18n.language == 'heb'
                    ? 'rounded-tr-[32px]'
                    : 'rounded-tl-[32px]'
                }`}
              >
                <Calendar />
              </div>
            )}
          </div>
        )}
      </div>

      <AddAnnouncement
        open={openAddEditAnnouncementDialog}
        onClose={handleCloseAddAnnouncementDialog}
        announcementData={selectedAnnouncementForEdit}
        mode={announcementModalMode}
      />

      <AddEditCheckList
        open={openAddCheckListDialog}
        onClose={handleCloseAddCheckListDialog}
      />

      <ChecklistApproval
        checklistId={showApproveChecklist as string}
        open={!!showApproveChecklist}
        onClose={() => setShowApproveChecklist(null)}
      />
    </>
  );
}

export default OperationsMain;
